import { colorsMatrix, HexColorDot, HexColorDotSize } from '@dreryk/react-components';

import { StyledCounter, StyledOverlapDot } from './PatientGroupMoreDot.styled';

type PatientGroupMoreDotProps = {
   counter: number;
};

export const PatientGroupMoreDot = (props: PatientGroupMoreDotProps): JSX.Element => {
   return (
      <StyledOverlapDot alignItems={'center'} justifyContent={'center'}>
         <HexColorDot testId={'dot'} color={colorsMatrix.blue.basic.slice(1)} size={HexColorDotSize.SMALL} />
         <StyledCounter testId={'counter'}>{`+${props.counter}`}</StyledCounter>
      </StyledOverlapDot>
   );
};
